export default __webpack_public_path__ + "static/media/illustration-health-2-w@2x.af9f1c50.webp";